import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Typography, TextField, Button, IconButton, DialogActions as MuiDialogActions, DialogTitle as MuiDialogTitle } from "@material-ui/core";
import ReplyTwoToneIcon from '@mui/icons-material/ReplyTwoTone';
import { withStyles } from "@material-ui/core/styles";
import {
	Close as CloseIcon, 
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,
  ArrowRightAltOutlined as ArrowRightAltOutlinedIcon,
} from "@material-ui/icons";
import "../Preview/DialPad.css";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BackspaceIcon from '@mui/icons-material/Backspace';

//store
import * as actions from "../../../../store/actions/actionIndex";
import { notify, validateDialInput } from "../../../../helpers/utility";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      width: "100%",
    },
  },
  
  deleteIcon: {
    marginTop: "8px!important",
  },
  backSpaceIcon: {
    marginTop: "2px!important",
    transform: "rotate(180deg)",
    fontSize: "45px!important",
  },
  phoneIcon: {
    marginTop: "8px!important",
  },
}));
const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: 0,
		top: 0,
		color: theme.palette.grey[500],
	},
	
});

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},

}))(MuiDialogActions);

function Dtmf(props) {
  const classes = useStyles();
   const [value, setValue] = React.useState("");
   const isValid = validateDialInput(value, "symbolDial");


   const handleKeypadPress = (d) => {
    setValue((prev) => prev + d);
  };


  const handleClear = () => setValue("");
  const handleBackspace = () => setValue((prev) => prev.slice(0, -1));

  const onInputChange = (e) => {
    const next = e.target.value;
    const cleaned = next.replace(/[^\d+#*]/g, "");
    setValue(cleaned.slice(0, 15));
  };

  const onNumberKeyDown = (e) => {
    // Enter should trigger dialing in both modes
    if (e.key === "Enter") {
      e.preventDefault();
      clickHandler();
      return;
    }
    const allowed =
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab" ||
      e.ctrlKey ||
      e.metaKey;

    if (allowed) return;
    const isDigit = /^[0-9]$/.test(e.key);
    const isPlus =
      e.key === "+" &&
      (value.length === 0 ||
        (window.getSelection?.()?.toString() ?? "") === value);
    const isStarOrHash = e.key === "*" || e.key === "#";
    if (!isDigit && !isPlus && !isStarOrHash) {
      e.preventDefault();
    }
  };



const clickHandler = () => {
const validation = validateDialInput(value, "symbolDial");
		if (!validation.valid) {
		  notify(validation.message, "validation-error");
		  return;
}  
props.onSendDtmf(props.agentId, value, props.channel, props.confFlag);
		setValue("");
  };


  const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography className="inner-dtmf-title" variant="h5">{children}</Typography>
			{/* {onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null} */}
		</MuiDialogTitle>
	);
});


  //84365387643
  return (
    <>
	<DialogTitle id="dtmf-dialog-title" className={classes.DialogTitle} onClose={props.handleDtmfClose} > 
								Send DTMF
							</DialogTitle>
      <DialogActions className=" dtmf-popup" style={{ display: "block" }}>
								<div className="dialpad compact position">
			 <div className="dials position" style={{ padding: "0px 5px" }}>
				<form className={classes.root} noValidate autoComplete="off">
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={value}
                onChange={onInputChange}
                onKeyDown={onNumberKeyDown}
                inputMode="numeric"
                inputProps={{ maxLength: 15 }}
                error={!isValid && value.length > 0}
                InputProps={{
                  endAdornment: value && (
                    <IconButton
                      onClick={handleBackspace}
                      size="small"
                      className="text-gray-500 hover:text-black"
                    >
                      <BackspaceIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
              />
                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "8px",
                  margin: "10px auto 0"
                }}>
                {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
                  <button
                    key={d}
                    onClick={() => handleKeypadPress(d)}
                    style={{
                        width: "110px",
                        height: "44px",
                        border: "1px solid #E0E0E0",
                        borderRadius: "10px",
                        background: "#FFFFFF",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#1F2937",
                        transition: "background 0.15s ease, transform 0.05s ease"
                      }}
                  >
                    {d}
                  </button>
                ))}
              </div>
              <div className="" style={{ display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around", marginTop: "10px", gap: "8px"}}>

					<button
                  onClick={() => handleKeypadPress("*")}
                  style={{
                    width: "100px",
                    height: "44px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    background: "#FFFFFF",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    cursor: "pointer",    
                    fontSize: "30px",
                    fontWeight: 600,
                    color: "#1F2937"
                  }}
                >
                  *
                </button>
                 <button
                  onClick={() => handleKeypadPress("0")}
                  style={{
                    width: "100px",
                    height: "44px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    background: "#FFFFFF",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    cursor: "pointer",    
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#1F2937"
                  }}
                >
                  0
                </button>
				  <button
                  onClick={() => handleKeypadPress("#")}
                  style={{
                    width: "100px",
                    height: "44px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    background: "#FFFFFF",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    cursor: "pointer",    
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "#1F2937"
                  }}
                >
                  #
                </button>
                </div>
              <div style={{  display: "flex",
                    alignItems: "center",
                    justifyContent: "center", margin: "10px 0", backgroundColor: "#f0f0f0", cursor: "pointer", padding: "10px"}}  onClick={handleClear}>
                <button
                  onClick={handleClear}
                  style={{
                    fontSize: "16px",
                    color: "#1F2937",
                    display:"flex",
                    alignItems:"center",
                     border: "none",
                     cursor: "pointer",
                  }}
                >
                  <RestartAltIcon fontSize="small" />
                  <span>Clear</span>
                </button>
              </div>
          <div className="" style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
          <Button
            variant="outlined"
            onClick={props.handleDtmfClose}
            className="flex-1 font-sans h-11"
          >
            Cancel
          </Button>
          <Button
            onClick={clickHandler}
            disabled={!isValid}
            variant="contained"
            // color="primary"
			// size="small"
            style={{backgroundColor: "#0a82da", color: "#fff"}}
            startIcon={<ReplyTwoToneIcon />}
          >
            Send
          </Button>
          </div>

            </form>
			 </div>
		  </div>
							</DialogActions>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
	loading: state.agentConf.loading,
	agentState: state.agentData.agentState,
	agentId: state.agentData.agentId,
  };
};

const mapDispatchToProps = (dispatch) => {
	return {
		onSendDtmf: (agentId, digit,channle, confFlag) => dispatch(actions.sendDtmf(agentId, digit, channle, confFlag)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Dtmf);
